import React from 'react';
import ChangePassword from './ChangePassword'
import ProfilePicture from './ProfilePicture'
import Notifications from './Notifications'
import { Route } from 'react-router'

class UserRoute extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Route path='/user/changepassword' component={ChangePassword}/>
                <Route path='/user/profilepicture' component={ProfilePicture}/>
                <Route path='/user/notifications' component={Notifications}/>
            </React.Fragment>
        )
    }
}

export default UserRoute;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/UserRoute/index.js